import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';

import { Observable, Subject, of } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { LanguageService } from '@fcom/ui-translate';
import { CmsTemplateService } from '@fcom/cms/services';
import { CmsTemplate } from '@fcom/core-api';
import { LoyaltyRoutesPath } from '@fcom/loyalty-core/interfaces';
import { PageMetaService } from '@fcom/common/services';
import { setPageMetadata } from '@fcom/loyalty-core';
import { ConfigService } from '@fcom/core';
import { Profile, LoginAddress } from '@fcom/core-api/login';
import { serializeParams } from '@fcom/core/utils';
import { ProfileService } from '@fcom/loyalty-profile/services/profile.service';

import { LEGACY_SITE_TIER_CODES } from '../../constants';

@Component({
  selector: 'fin-buy-points',
  templateUrl: 'buy-points.component.html',
  styleUrls: ['../../../loyalty-core/assets/styles/common.scss'],
})
export class BuyPointsComponent implements OnInit, OnDestroy, AfterViewInit {
  template$: Observable<CmsTemplate>;
  pageTitle$: Observable<string>;
  pageViewType$: Observable<string> = of('');
  showSideTitle$: Observable<boolean> = of(false);
  iframeUrl$: Observable<string>;
  profile$: Observable<Profile>;

  private ngDestroyed$ = new Subject();

  constructor(
    private cmsTemplateService: CmsTemplateService,
    private languageService: LanguageService,
    private pageMetaService: PageMetaService,
    private configService: ConfigService,
    private profileService: ProfileService
  ) {}

  ngOnInit() {
    this.profile$ = this.profileService.getFullProfile();

    this.template$ = this.cmsTemplateService.load(
      `/${this.languageService.langValue}/${LoyaltyRoutesPath.PLUS}/${LoyaltyRoutesPath.BUY_POINTS}`
    );
    this.pageTitle$ = this.template$.pipe(map((template: CmsTemplate) => template?.header?.[0]?.title ?? ''));

    this.iframeUrl$ = this.createIframeUrl();
  }

  ngAfterViewInit(): void {
    this.template$
      .pipe(takeUntil(this.ngDestroyed$))
      .subscribe((template: CmsTemplate) => setPageMetadata(template, this.pageMetaService));
  }

  ngOnDestroy(): void {
    this.ngDestroyed$.next(true);
  }

  createIframeUrl(): Observable<string> {
    return this.profile$.pipe(
      map((memberProfile: Profile) => {
        const address: LoginAddress = memberProfile.addresses.find((a) => !!a.primary);

        const params = {
          ssoSource: 'Finnair',
          ssoProduct: 'Buy',
          FinnairPlusMember: memberProfile.memberNumber,
          Firstname: memberProfile.firstname,
          Lastname: memberProfile.lastname,
          AccountBalance: memberProfile.awardPoints.toString(),
          Country: address?.country,
          Zip: address?.postalCode,
          Language: this.languageService.langValue,
          MemberTier: LEGACY_SITE_TIER_CODES[memberProfile.tier],
          MemberEmail: memberProfile.email,
          MemberJoinDate: memberProfile.joinDate,
          MemberStatus: memberProfile.status.substring(0, 1),
          CoBrandCard: memberProfile.sebCard ? 'Y' : 'N',
        };

        return `${this.configService.cfg.buyPointsIframeUrl}?${serializeParams(params)}`;
      })
    );
  }
}
